import moment from "moment"

export const calculateMonths = (monthsArray) => {

  if (!Array.isArray(monthsArray) || monthsArray.length === 0) {
    return 0
  }
    
  let totalMonths = 0

  monthsArray.forEach(range => {
    const [start, end] = range

    const startDate = moment(start, "YYYYMMDD")
    const endDate = moment(end, "YYYYMMDD")

    const diff = endDate.diff(startDate, "months", true)

    totalMonths += Math.ceil(diff)
  })

  return totalMonths
}

export const calculateMonthlyAverage = (goal, monthsArray) => {
  const totalMonths = calculateMonths(monthsArray)

  if (!goal || !totalMonths) return 0

  const avg = Number(goal) / totalMonths
  return Math.round(avg * 100) / 100
}